import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.js";
import fr from "./locales/fr.js";
import es from "./locales/es.js";
import it from "./locales/it.js";
import sw from "./locales/sw.js";
import ar from "./locales/ar.js";
import de from "./locales/de.js";
import nl from "./locales/nl.js";
import zh from "./locales/zh.js";
import ko from "./locales/ko.js";
import ru from "./locales/ru.js";

export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "fr", label: "French", native: "Français" },
  { code: "es", label: "Spanish", native: "Español" },
  { code: "it", label: "Italian", native: "Italiano" },
  { code: "sw", label: "Swahili", native: "Kiswahili" },
  { code: "ar", label: "Arabic", native: "العربية", rtl: true },
  { code: "de", label: "German", native: "Deutsch" },
  { code: "nl", label: "Dutch", native: "Nederlands" },
  { code: "zh", label: "Chinese", native: "中文" },
  { code: "ko", label: "Korean", native: "한국어" },
  { code: "ru", label: "Russian", native: "Русский" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      it: { translation: it },
      sw: { translation: sw },
      ar: { translation: ar },
      de: { translation: de },
      nl: { translation: nl },
      zh: { translation: zh },
      ko: { translation: ko },
      ru: { translation: ru },
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "donitshit_lang",
    },
  });

const applyDir = (lng) => {
  const isRtl = LANGUAGES.find((l) => l.code === lng)?.rtl;
  document.documentElement.setAttribute("dir", isRtl ? "rtl" : "ltr");
  document.documentElement.setAttribute("lang", lng);
};
applyDir(i18n.language || "en");
i18n.on("languageChanged", applyDir);

export default i18n;
